module.exports = __webpack_public_path__ + "img/04.77c7fcec.gif";